import React from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../components/commentBox";
import TaskCheckedList from "../../../components/taskCheckedList";
import PageHeader from "../../../components/pageHeader";

function RefundProcess() {
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Refund Process:" />
          </Col>
          <Col span={24}>
            <h1>There is nothing here</h1>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Next</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
          <CommentBox />
          </Col>
          <Col span={24}>
          <TaskCheckedList />
          </Col>
        </Row>

      </Form>
    </div>
  );
}

export default RefundProcess;

